import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-marathi-rajbhasha',
  templateUrl: './marathi-rajbhasha.component.html',
  styleUrls: ['./marathi-rajbhasha.component.scss']
})
export class MarathiRajbhashaComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
